module.exports = __webpack_public_path__ + "static/media/revenue.4ce79a74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/partner-reports/revenue.svg
// module id = 1120
// module chunks = 1